// src/pages/PrivacyPolicy.jsx
import LegalLayout from "../components/LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout
      title="Gizlilik Politikası"
      updatedAt="18.12.2025"
      subtitle="Bu metin, KolayYük mobil uygulamasını kullanan kullanıcıların kişisel verilerinin hangi kapsamda toplandığını, nasıl kullanıldığını ve nasıl korunduğunu açıklamak amacıyla hazırlanmıştır."
    >
      {/* 1 */}
      <Section title="1. Genel Bilgilendirme">
        <p className={styles.p}>
          Bu Gizlilik Politikası, KolayYük mobil uygulamasının (“Uygulama”)
          kullanıcılarına ait kişisel verilerin hangi kapsamda toplandığını,
          nasıl kullanıldığını ve nasıl korunduğunu açıklamak amacıyla
          hazırlanmıştır.
        </p>
        <p className={styles.p}>
          KolayYük, henüz ticari faaliyete geçmemiş bir MVP (Minimum Viable
          Product) niteliğinde olup, kullanıcılar arasında yük ve taşıma
          bilgilerine ilişkin eşleştirme ve bilgilendirme amacıyla hizmet
          sunmaktadır.
        </p>
        <p className={styles.p}>
          Uygulamayı kullanan her kullanıcı, işbu Gizlilik Politikası’nı
          okuduğunu ve kabul ettiğini beyan etmiş sayılır.
        </p>
      </Section>

      {/* 2 */}
      <Section title="2. Veri Sorumlusu">
        <p className={styles.p}>
          KolayYük uygulaması kapsamında işlenen kişisel verilerin veri sorumlusu:
        </p>
        <p className={styles.p}>
          <strong>Süleyman Kaan Büyükkatırcı</strong>
          <br />
          İletişim:{" "}
          <a className={styles.a} href="mailto:info@kolayyuk.com">
            info@kolayyuk.com
          </a>
        </p>
      </Section>

      {/* 3 */}
      <Section title="3. Toplanan Kişisel Veriler">
        <p className={styles.p}>
          KolayYük kapsamında, uygulamanın çalışması için gerekli olan asgari düzeyde
          kişisel veri toplanmaktadır.
        </p>

        <h3 className={styles.h3}>3.1 Kimlik ve İletişim Bilgileri</h3>
        <ul className={styles.ul}>
          <li className={styles.li}>Ad, soyad</li>
          <li className={styles.li}>Telefon numarası</li>
          <li className={styles.li}>(Varsa) e-posta adresi</li>
        </ul>

        <h3 className={styles.h3}>3.2 Kullanım ve Teknik Veriler</h3>
        <ul className={styles.ul}>
          <li className={styles.li}>Uygulama içi etkileşimler</li>
          <li className={styles.li}>Hata ve performans kayıtları</li>
          <li className={styles.li}>
            Cihaz bilgileri (işletim sistemi, uygulama sürümü)
          </li>
        </ul>

        <h3 className={styles.h3}>3.3 Bildirim Verileri</h3>
        <ul className={styles.ul}>
          <li className={styles.li}>
            Bildirim gönderimi amacıyla kullanılan cihaza özgü teknik tanımlayıcılar
            (Expo Push Token)
          </li>
        </ul>

        <h3 className={styles.h3}>3.4 Konum Bilgileri</h3>
        <p className={styles.p}>
          Kullanıcının açık izniyle, yalnızca uygulama içi eşleştirme ve harita gösterimi
          amacıyla kullanılan yaklaşık veya hassas konum bilgileri.
        </p>

        <p className={styles.p}>
          KolayYük; TC kimlik numarası, banka/ödeme bilgileri, biyometrik veri,
          video veya ses kaydı <strong>toplamaz ve işlemez.</strong>
        </p>
      </Section>

      {/* 4 */}
      <Section title="4. Kişisel Verilerin İşlenme Amaçları">
        <ul className={styles.ul}>
          <li className={styles.li}>Kullanıcı hesabı oluşturulması ve yönetimi</li>
          <li className={styles.li}>Telefon numarası doğrulama işlemleri</li>
          <li className={styles.li}>Yük ve taşıma bilgilerinin eşleştirilmesi</li>
          <li className={styles.li}>Uygulama içi bildirimlerin gönderilmesi</li>
          <li className={styles.li}>Sistem güvenliğinin sağlanması</li>
          <li className={styles.li}>Uygulamanın geliştirilmesi ve iyileştirilmesi</li>
        </ul>

        <p className={styles.p}>
          Uygulamanın performansının ölçülmesi, hataların tespiti ve kullanıcı deneyiminin
          iyileştirilmesi amacıyla, anonim ve istatistiksel nitelikte uygulama kullanım
          verileri Firebase Analytics gibi analitik hizmetler aracılığıyla işlenebilir.
          Bu veriler, kullanıcıyı doğrudan tanımlamaya yönelik değildir.
        </p>
      </Section>

      {/* 5 */}
      <Section title="5. Kişisel Verilerin Saklanması ve Aktarımı">
        <p className={styles.p}>
          Kişisel veriler, güvenli bulut altyapıları üzerinde saklanmaktadır.
        </p>
        <ul className={styles.ul}>
          <li className={styles.li}>Google Firebase</li>
          <li className={styles.li}>Expo</li>
          <li className={styles.li}>Cloudflare (CDN ve güvenlik)</li>
        </ul>
        <p className={styles.p}>
          Bu hizmet sağlayıcıların yurt dışı sunucuları kullanılabilir. Aktarım,
          kullanıcının açık rızasına dayalı olarak ve KVKK’nın 9. maddesine uygun şekilde
          gerçekleştirilir.
        </p>
      </Section>

      {/* 6 */}
      <Section title="6. Veri Güvenliği">
        <ul className={styles.ul}>
          <li className={styles.li}>Yetkilendirme ve erişim kontrolleri</li>
          <li className={styles.li}>Şifreli veri iletimi (HTTPS)</li>
          <li className={styles.li}>Güvenli bulut altyapısı</li>
          <li className={styles.li}>Rol bazlı erişim sınırlamaları</li>
        </ul>
      </Section>

      {/* 7 */}
      <Section title="7. Kullanıcı Hakları">
        <p className={styles.p}>
          Kullanıcılar, 6698 sayılı KVKK’nın 11. maddesi kapsamında kişisel verilerine
          ilişkin haklarını kullanabilir.
        </p>
        <p className={styles.p}>
          Talepler{" "}
          <a className={styles.a} href="mailto:info@kolayyuk.com">
            info@kolayyuk.com
          </a>{" "}
          adresi üzerinden iletilebilir.
        </p>
      </Section>

      {/* 8 */}
      <Section title="8. Gizlilik Politikasında Değişiklik">
        <p className={styles.p}>
          KolayYük, işbu Gizlilik Politikası’nı güncelleme hakkını saklı tutar.
          Güncel metin yayımlandığı tarihte yürürlüğe girer.
        </p>
      </Section>

      {/* 9 */}
      <Section title="9. Yürürlük">
        <p className={styles.p}>
          İşbu Gizlilik Politikası, kullanıcının uygulamayı kullanmasıyla birlikte
          yürürlüğe girer.
        </p>
      </Section>
    </LegalLayout>
  );
}

function Section({ title, children }) {
  return (
    <section className="mt-10">
      <h2 className="text-xl font-extrabold text-black">{title}</h2>
      <div className="mt-3">{children}</div>
    </section>
  );
}

const styles = {
  p: "text-gray-700 leading-relaxed mt-3",
  h3: "mt-6 text-base font-bold text-black",
  ul: "mt-3 ml-5 list-disc text-gray-700 leading-relaxed",
  li: "mt-2",
  a: "text-black underline underline-offset-4",
};
